import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#123B63',
      dark: '#0D2E4E',
      light: '#315981',
      contrastText: '#F8FAFC',
    },
    secondary: {
      main: '#C69214',
      dark: '#A57609',
      light: '#D8AB46',
      contrastText: '#0F172A',
    },
    success: {
      main: '#1F7A5A',
    },
    warning: {
      main: '#C27A0A',
    },
    error: {
      main: '#B42318',
    },
    background: {
      default: '#F3F6FA',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#0F172A',
      secondary: '#5B677A',
    },
    divider: '#D7E0EA',
  },
  shape: {
    borderRadius: 14,
  },
  typography: {
    fontFamily: '"Manrope", system-ui, sans-serif',
    h1: {
      fontFamily: '"IBM Plex Sans", "Manrope", system-ui, sans-serif',
      fontWeight: 700,
      letterSpacing: '-0.04em',
    },
    h2: {
      fontFamily: '"IBM Plex Sans", "Manrope", system-ui, sans-serif',
      fontWeight: 700,
      letterSpacing: '-0.035em',
    },
    h3: {
      fontFamily: '"IBM Plex Sans", "Manrope", system-ui, sans-serif',
      fontWeight: 700,
      letterSpacing: '-0.03em',
    },
    h4: {
      fontFamily: '"IBM Plex Sans", "Manrope", system-ui, sans-serif',
      fontWeight: 700,
      letterSpacing: '-0.03em',
    },
    h5: {
      fontWeight: 700,
      letterSpacing: '-0.02em',
    },
    h6: {
      fontWeight: 700,
      letterSpacing: '-0.02em',
    },
    button: {
      fontWeight: 700,
      textTransform: 'none',
      letterSpacing: '-0.01em',
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#F3F6FA',
        },
      },
    },
    MuiPaper: {
      defaultProps: {
        elevation: 0,
      },
      styleOverrides: {
        root: {
          border: '1px solid #D7E0EA',
          boxShadow: '0 20px 45px -28px rgba(15, 23, 42, 0.28)',
          backgroundImage: 'none',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          paddingInline: 18,
          paddingBlock: 10,
        },
        containedPrimary: {
          boxShadow: '0 14px 32px -22px rgba(18, 59, 99, 0.8)',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          backgroundColor: '#FFFFFF',
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
  },
});

export default theme;
